import mapLocaleToEditorSupported from './mapLocaleToEditorSupported';

// The uploader keys its Uppy bundles with an underscore ('de_DE') and falls back to English for a
// locale it has no bundle for, so a market it does not cover yet degrades instead of breaking.
const mapLocaleToUploaderLocale = (opLocale: string) => mapLocaleToEditorSupported(opLocale).replace('-', '_');

export default mapLocaleToUploaderLocale;
